import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { IDropdownItem, SimpleResult } from "@ryde/shared";

import { landingRoutesApiConst } from "../constants";
import { landingCompanyIdSelector } from "../selectors";
import { useLandingApiMethods } from "./use-landing-api-methods";

export const useLandingApiSites = () => {
  const companyId = useRecoilValue(landingCompanyIdSelector);
  const sitesUrl = landingRoutesApiConst.sites(companyId as number);
  const { apiGet } = useLandingApiMethods();

  const getSitesDropdownItems = useEvent(
    async (): Promise<SimpleResult<IDropdownItem[]> | undefined> => {
      const response = await apiGet<SimpleResult<IDropdownItem[]>>(
        sitesUrl.getDropdownItems,
      );

      return response?.data;
    },
  );

  return { getSitesDropdownItems };
};
